module.exports = "https://static.wmbcdn.com/uniweb/images/68d902b49dc9711d0a95a622ca738cdd.svg";